
import React from 'react';

interface UsersPageHeaderProps {
  totalUsers: number;
}

export const UsersPageHeader: React.FC<UsersPageHeaderProps> = ({ totalUsers }) => {
  return (
    <div className="flex flex-col md:flex-row items-start md:items-center justify-between mb-8">
      <div>
        <h1 className="text-3xl font-bold text-white mb-2">
          Gerenciar Usuários
        </h1>
        <p className="text-gray-400">
          {totalUsers} usuários registrados na plataforma.
        </p>
      </div>
    </div>
  );
};
